<!-- 小猪班纳 主页 - 视频背景（桌面+微信兼容方案） -->
<template>
<div>
    <!-- ========================================== -->
    <!-- 视频背景：桌面端 HTML5 Video / 微信端 Canvas+JSMpeg   -->
    <!-- ========================================== -->
    
    <!-- 方式1: 桌面 & 非微信浏览器 → 标准 video 标签（autoplay muted 原生可用） -->
    <div class="video-wrapper" v-if="!useCanvas" :class="{ 'video-hidden': isMenuOpen }">
        <video id="vd" :src="pVideo"
            @click="v_play($event)"
            autoplay loop muted playsinline webkit-playsinline
            x5-video-player-type="h5" x5-video-player-fullscreen="false"
            preload="auto">
        </video>
    </div>
    
    <!-- 方式2: 微信浏览器 → Canvas + JSMpeg（绕过 <video> 自动播放限制） -->
    <div class="video-wrapper" v-show="useCanvas" :class="{ 'video-hidden': isMenuOpen }">
        <canvas ref="videoCanvas" id="videoCanvas"></canvas>
        <!-- 加载封面：JSMpeg 还未开始解码时显示 -->
        <div v-if="!jsmpegReady" class="canvas-loading">
            <img src="@/assets/pig.png" alt="pepco" />
        </div>
    </div>
    
    <!-- ========================================== -->
    <!-- 导航区域                                      -->
    <!-- ========================================== -->
    <div class="home-container">
    <transition name="el-zoom-in-top">
    <div id="nav" v-show="show">
    <!-- 桌面端导航 -->
    <div class="desktop-nav">
      <img src="@/assets/pig.png" class="logo"/>
      <div id="toNav">
        <ul>
          <li @click="$router.push('/introduction/index')"><h4>公司简介</h4></li>
          <li @click="$router.push('/corporateImage/index')"><span>|</span><h4>形象大片</h4></li>
          <li @click="$router.push('/brandInformation/index')"><span>|</span><h4>品牌资讯</h4></li>
          <li @click="$router.push('/franchise/index')"><span>|</span><h4>加盟信息</h4></li>
          <li @click="$router.push('/ambassador/index')"><span>|</span><h4>体验官计划</h4></li>
        </ul>
      </div>
    </div>
    <!-- 移动端导航 -->
    <MobileNav :menuItems="menuItems"></MobileNav>
  </div>
  </transition>
  </div>
</div>
</template>

<script>
import MobileNav from '@/components/MobileNav.vue';

export default {
components: { MobileNav },
data() {
return {
  show: false,
  isMenuOpen: false,

  /* ---- 视频 URL ---- */
  pVideo: process.env.VUE_APP_HOME_VIDEO_URL,
  // 微信端 TS 流（需用 ffmpeg 转换：ffmpeg -i homePage.mp4 -f mpegts -codec:v mpeg1video -codec:a mp2 -b 0 homePage.ts）
  pTsVideo: process.env.VUE_APP_HOME_TS_VIDEO_URL,

  /* ---- 微信 JSMpeg 状态 ---- */
  useCanvas: false,        // true=微信环境使用 Canvas
  jsmpegReady: false,      // JSMpeg 已开始解码

  /* ---- 菜单 ---- */
  menuItems: [
    { name: '公司简介', path: '/introduction/index' },
    { name: '形象大片', path: '/corporateImage/index' },
    { name: '品牌资讯', path: '/brandInformation/index' },
    { name: '加盟信息', path: '/franchise/index' },
    { name: '体验官计划', path: '/ambassador/index' }
  ]
};
},

methods: {
  // ── 桌面端 video 交互 ──
  v_play({ target }) {
    const vd = target || document.getElementById('vd')
    if (vd) vd.muted = !vd.muted
  },

  // ── 微信端 Canvas 自适应 ──
  resizeCanvas() {
    const canvas = this.$refs.videoCanvas
    if (!canvas) return
    const w = window.innerWidth
    const h = window.innerHeight
    if (canvas.width !== w || canvas.height !== h) {
      canvas.width = w
      canvas.height = h
    }
  },

  // ── 微信端 JSMpeg 初始化（核心）──
  initJsmpeg() {
    const canvas = this.$refs.videoCanvas
    if (!canvas || this._player) return

    this.resizeCanvas()
    this._resizeHandler = () => this.resizeCanvas()
    window.addEventListener('resize', this._resizeHandler)

    try {
      // JSMpeg.Player 来自 public/jsmpeg.min.js（全局挂载）
      // eslint-disable-next-line no-undef
      this._player = new JSMpeg.Player(this.pTsVideo, {
        canvas: canvas,
        autoplay: true,       // 关键！Canvas 不受 video 策略限制
        loop: true,
        audio: false,         // 静音 = 更稳定
        disableGl: false,     // 启用 WebGL 渲染（性能更好）
        preserveDrawingBuffer: true,
        onPlay: () => {
          this.jsmpegReady = true
        },
        onError: () => {
          console.warn('[JSMpeg] 播放异常，回退到 video 标签')
          this.fallbackToVideo()
        }
      })
    } catch (e) {
      console.warn('[JSMpeg] 初始化失败', e)
      this.fallbackToVideo()
    }
  },

  // ── 失败回退：转换为普通 video（用户可点击播放）──
  fallbackToVideo() {
    this.destroyJsmpeg()
    this.useCanvas = false
    this.$nextTick(() => {
      const vd = document.getElementById('vd')
      if (vd) vd.play().catch(() => {})
    })
  },

  // ── 清理 JSMpeg ──
  destroyJsmpeg() {
    if (this._player) {
      try { this._player.destroy() } catch(e) { /* ignore */ }
      this._player = null
    }
    if (this._resizeHandler) {
      window.removeEventListener('resize', this._resizeHandler)
      this._resizeHandler = null
    }
  },

  // ── 菜单开关 ──
  onMenuToggle(event) {
    this.isMenuOpen = event.detail.isOpen;
  }
},

// ── 生命周期 ──
created() {
  window.addEventListener('mobile-menu-toggle', this.onMenuToggle)
  // 仅微信内置浏览器启用 Canvas 方案
  this.useCanvas = /MicroMessenger/i.test(navigator.userAgent)
},
mounted() {
  this.show = true
  if (this.useCanvas) {
    this.$nextTick(() => this.initJsmpeg())
  } else {
    // 桌面端：直接播放 video
    const vd = document.getElementById('vd')
    if (vd) { vd.load(); vd.play().catch(() => {}) }
  }
},
beforeDestroy() {
  window.removeEventListener('mobile-menu-toggle', this.onMenuToggle)
  this.destroyJsmpeg()
},
activated() {
  // keep-alive 激活时重新初始化
  if (this.useCanvas) {
    this.jsmpegReady = false
    this.$nextTick(() => this.initJsmpeg())
  } else {
    const vd = document.getElementById('vd')
    if (vd) { vd.load(); vd.play().catch(() => {}) }
  }
},
}
</script>

<style lang='scss' scoped>
/* ========== 导航栏 ========== */
#nav{
  width:100%;
  border-radius: 0px 0px 35px 35px;
  background-color:rgba($color: #fbfbfb, $alpha: 0.6);
  position:absolute;
  z-index: 1000;
  transition: background-color 0.5s ease;
}
#nav:hover{
  background-color:rgba($color: #fbfbfb, $alpha: 1);
}

.desktop-nav {
  display: flex;
  align-items: center;
  justify-content:space-between;
  width:100%;
  height:90px;
  
  @media screen and (max-width: 768px) {
    display: none;
  }
}

#toNav{
  margin-right: 4%;
}
#toNav li{
  display: inline-block;
  margin-right:20px;
  text-align: center;
}
#toNav span{
  margin-right: 20px;
  display: inline-block;
  font-size: 20px;
  font-weight:900;
  margin-bottom: -3px;
}
#toNav h4{
  display: inline-block;
  padding:9px 20px 8px 20px;
  font-size: 25px;
  line-height: 25px;
  border-radius: 15px;
  transition:border-radius 0.5s ease,background-color 0.5s ease,color 0.5s ease;
  cursor: pointer;
}
#toNav h4:hover{
  border-radius: 15px;
  background-color: black;
  color:white;
}
.logo{
  margin-left:4%;
  width:150px;
  height:42px;
}

/* ========== 视频容器（桌面+微信共用） ========== */
.video-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    overflow: hidden;
    
    &.video-hidden {
        display: none !important;
        opacity: 0 !important;
        pointer-events: none !important;
    }
}

/* 桌面端 video 元素 */
.video-wrapper video {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

/* 微信端 Canvas 元素 */
.video-wrapper canvas {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
}

/* JSMpeg 加载中封面 */
.canvas-loading {
    position: absolute;
    top: 0; left: 0;
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 5;
}
.canvas-loading img {
    width: 180px;
    opacity: 0.5;
    animation: fadeIn 0.3s ease;
}
@keyframes fadeIn {
    from { opacity: 0; }
    to   { opacity: 0.5; }
}

/* ========== 导航容器层级 ========== */
.home-container {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 2;
  pointer-events: none;
}

.home-container > * {
  pointer-events: auto;
}
</style>
